import { createRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Route as appRoute } from '../../_app'
import { useRequireAdmin } from '../../../lib/me-context'
import { AdminShell } from '../../../components/admin/AdminShell'
import { AdminImportPanel } from '../../../components/admin/AdminImportPanel'
import { AdminBankTable } from '../../../components/admin/AdminBankTable'

/**
 * Admin Question Bank (`/admin/question-bank`) — bulk-import CSV/Excel into the
 * public bank and manage (create/edit/delete) any item across orgs. Guarded by
 * {@link useRequireAdmin}.
 */
export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: '/admin/question-bank',
  component: AdminQuestionBankPage,
})

function AdminQuestionBankPage() {
  const { t } = useTranslation('admin')
  const isAdmin = useRequireAdmin()

  if (!isAdmin) {
    return null
  }

  return (
    <AdminShell active="questionBank" title={t('adminBankTitle')}>
      <div className="space-y-8">
        <AdminImportPanel />
        <AdminBankTable />
      </div>
    </AdminShell>
  )
}
